module.exports = __webpack_public_path__ + "media/images/icon__infoBox-6fd2eb823d9750f0246a27adaa80f544.png";